import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";
import { puedeCrm } from "./permisosCrm";

// (2026-10) Menú del CRM (portado de EnvasesBH) con los botones de Langiani.
const BOTONES = [
  { label: "Prospectos", icon: "fas fa-user-plus", color: "#2563eb", href: "/CrmProspectos", clave: "crm.prospectos.ver" },
  { label: "Oportunidades", icon: "fas fa-handshake", color: "#2563eb", href: "/CrmOportunidades", clave: "crm.oportunidades.ver" },
  { label: "Embudo de Ventas", icon: "fas fa-stream", color: "#2563eb", href: "/CrmPipeline", clave: "crm.embudo.ver" },
  { label: "Acciones Pendientes", icon: "fas fa-calendar-check", color: "#2563eb", href: "/CrmReportePendientes", clave: "crm.pendientes.ver" },
  { label: "Etapas", icon: "fas fa-sliders-h", color: "#2563eb", href: "/CrmEtapas", clave: "crm.etapas.ver" },
];

function BotonesCrm() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "", items: BOTONES.map((b) => ({ ...b, enabled: !!(user.menu_crm && puedeCrm(user, b.clave)) })) },
  ];

  return (
    <MenuBotones
      titulo="CRM"
      descripcion="Prospectos, oportunidades y embudo de ventas"
      icono="fas fa-handshake"
      color="#2563eb"
      secciones={secciones}
    />
  );
}

export default BotonesCrm;
